import { render, staticRenderFns } from "./CustomerCustomerMessageHistory.vue?vue&type=template&id=43128aa7"
import script from "./CustomerCustomerMessageHistory.vue?vue&type=script&lang=js"
export * from "./CustomerCustomerMessageHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports